import gql from "graphql-tag";

const fragmentName = "ProductDetail";

const fragment = gql`
  fragment ${fragmentName} on Product {
    id
    code
    name
    slug
    logo
    partner
    redirect
    enabled
    active
    conversion
    productAttributes {
      descriptor
      value
      level
      enabled
      isAccurate
      featured
      extraDescription
      entity {
        icon
        label
        config
        group
        dataType
        code
        extraDescription
        config
      }
    }
    division {
      code
      logo
      name
    }
  }
`;

export { fragment, fragmentName };
